import Warning from 'app/components/icons/Warning.svg';
import { TProps } from './types/TProps';

export const GenericPageError = ({ message, className = 'page-error' }: TProps) => {
  if (!message) {
    return <></>;
  }
  return (
    <p
      className={`relative mb-5 inline-block rounded-[10px] border border-[var(--color-danger)] px-4 py-2 pl-10 text-left text-base font-normal leading-[150%] text-[var(--color-danger)] ${className}`.trim()}
    >
      <Warning className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2" />
      {message}
    </p>
  );
};
